export default "https://cdn-web.disco.co/control-logo-d46e2911b11a6029d2eed1b40097b4bf.png";